import { useQuery } from '@tanstack/react-query';
import { FindAllTicketsResponse } from '../../../support';
import api from '../../http';
import { toApiError } from '../utils';

interface UseGetSupportTicketsParams {
	page?: number;
	limit?: number;
	status?: string;
	period?: string;
	sortOrder?: string;
	customDateFrom?: string;
	customDateTo?: string;
	enabled?: boolean;
}

export function useGetSupportTickets({
	page = 1,
	limit = 6,
	status,
	period,
	sortOrder,
	customDateFrom,
	customDateTo,
	enabled = true,
}: UseGetSupportTicketsParams = {}) {
	const query = useQuery<FindAllTicketsResponse>({
		queryKey: [
			'support',
			'tickets',
			page,
			limit,
			status,
			period,
			sortOrder,
			customDateFrom,
			customDateTo,
		],
		enabled,
		placeholderData: (previousData) => previousData,
		queryFn: async () => {
			try {
				const { data } = await api.get<FindAllTicketsResponse>('/support-tickets/findAll', {
					params: {
						page,
						limit,
						...(status && status !== 'all' ? { status } : {}),
						...(period && period !== 'all' ? { period } : {}),
						...(sortOrder ? { sortOrder } : {}),
						...(customDateFrom ? { customDateFrom } : {}),
						...(customDateTo ? { customDateTo } : {}),
					},
				});

				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao buscar tickets de suporte.');
			}
		},
	});

	return {
		...query,
		data: query.data?.docs ?? [],
		pagination: query.data
			? {
					totalDocs: query.data.totalDocs,
					totalPages: query.data.totalPages,
					page: query.data.page,
					limit: query.data.limit,
				}
			: null,
	};
}
